import { configureStore, combineReducers } from "@reduxjs/toolkit";
import accountListReducer from "../features/accountListSlice";
import productItemReducer from "../redux/productItem/productItemSlice";
import productItemUnitReducer from "../redux/itemUnit/productItemUnitSlice";
import unitConvertionHistoryReducer from "../redux/unitConvertionHistory/unitConvertionHistorySlice";
import unitRelationReducer from "../redux/unitRelation/unitRelationSlice";
import authReducer from "./authRedux";
import apiReducer from "./apiRedux";
import refreshReducer from "./refreshSlice";
import purchaseRequestReducer from "./purchaseRequest/purchaseRequestSlice";
import filterUnitReducer from "./itemUnit/filterUnitSlice";
import filterStockBatchReducer from "./stockBatch/fitlerStockBatchSlice";
import filterPurchaseVoucherReducer from "./purchaseVoucher/purchaseVoucherSlice";
import filterStockCountAndPriceReducer from "./stockCountAndPrice/stockCountAndPriceSlice";
import filterStockHistoryReducer from "./stockHistory/stockHistorySlice";

const rootReducer = combineReducers({
  auth: authReducer,
  api: apiReducer,
  productItem: productItemReducer,
  productItemUnit: productItemUnitReducer,
  unitConvertionHistory: unitConvertionHistoryReducer,
  unitRelation: unitRelationReducer,
  purchaseRequest: purchaseRequestReducer,
  refresh: refreshReducer,
  filterItemUnit: filterUnitReducer,
  filterStockBatch: filterStockBatchReducer,
  filterPurchaseVoucher: filterPurchaseVoucherReducer,
  filterStockCountAndPrice: filterStockCountAndPriceReducer,
  filterStockHistory: filterStockHistoryReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  accountList: accountListReducer,
});
